var map = {
	"./Burgenland.png": 4020,
	"./BurgenlandFlag.png": 2456,
	"./Kaernten.png": 3225,
	"./KaerntenFlag.png": 1281,
	"./Niederoesterreich.png": 5175,
	"./NiederoesterreichFlag.png": 395,
	"./OberoesterreichFlag.png": 3507,
	"./Oesterreich.png": 9864,
	"./Salzburg.png": 467,
	"./SalzburgFlag.png": 8154,
	"./SteiermarkFlag.png": 500,
	"./Tirol.png": 8409,
	"./TirolFlag.png": 1233,
	"./VorarlbergFlag.png": 4030,
	"./Wien.png": 5390,
	"./WienFlag.png": 743,
	"./oeskb.png": 5473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;